import { LogoMark } from "./Logo";

export const RingBadge = () => (
  <div className="relative w-28 h-28 sm:w-36 sm:h-36 rounded-full bg-[#FBFBF8] shadow-xl grid place-items-center" data-testid="hero-ring-badge">
    <svg viewBox="0 0 200 200" className="absolute inset-0 w-full h-full animate-spin-slow">
      <defs><path id="ring" d="M100,100 m-74,0 a74,74 0 1,1 148,0 a74,74 0 1,1 -148,0" /></defs>
      <text className="fill-[#2D2A26]" style={{ fontSize: 15, letterSpacing: 4, textTransform: "uppercase" }}>
        <textPath href="#ring" textLength="462" lengthAdjust="spacing">Worthy · Deserving · The Gift ·</textPath>
      </text>
    </svg>
    <LogoMark className="w-9 h-9 text-[#2D2A26]" />
  </div>
);
